import React, {useState} from 'react';
import {
   Image,
   Text,
   View,
   StyleSheet,
   Dimensions,
   TouchableOpacity,
} from 'react-native';
import {
   moduleCountBGColor,
   drawerListBackgroundColor,
   lockedCourseBGColor,
   moduleListRowBGColor,
   courseSerialNumberColor,
   FONT_FAMILY_REGULAR,
   WHITE_ICON_HOVER_TINT_COLOR,
   WHITE_TEXT_HOVER_COLOR,
} from '../../utils/utils';

const {width, height} = Dimensions.get('window');
const rowHeight =
   Dimensions.get('window').height > Dimensions.get('window').width ? 40 : 64;
const IconSize =
   Dimensions.get('window').height > Dimensions.get('window').width ? 24 : 48;
const isLandscapeMode =
   Dimensions.get('window').height > Dimensions.get('window').width
      ? false
      : true;
const textWidth = width - 16 * 2 - rowHeight - 10 * 2 - IconSize - 5 * 2;

const CourseResourceItem = ({title, titleColor, isSelected, index, locked}) => {
   const [isHover, setHover] = useState(false);
   return (
      <View
         style={{marginHorizontal: 16}}
         onMouseEnter={() => setHover(true)}
         onMouseLeave={() => setHover(false)}>
         {/** Unlocked courses and locked courses have different parent views */}

         <View style={styles.item}>
            <View
               style={{
                  flexDirection: 'row',
                  justifyContent: 'center',
                  alignItems: 'center',
               }}>
               <Text
                  numberOfLines={2}
                  style={[
                     styles.title,
                     isHover && {color: WHITE_TEXT_HOVER_COLOR},
                  ]}>
                  {title}
               </Text>
            </View>

            <View
               style={{
                  flexDirection: 'row',
                  justifyContent: 'center',
                  alignItems: 'center',
               }}>
               <View
                  style={{
                     borderRadius: 4,
                     height: IconSize,
                     width: IconSize,
                     alignContent: 'center',
                     alignItems: 'center',
                     justifyContent: 'center',
                     marginHorizontal: 5,
                  }}>
                  <Image
                     style={{
                        width: IconSize,
                        height: IconSize,
                        tintColor: isHover
                           ? WHITE_ICON_HOVER_TINT_COLOR
                           : 'rgba(181,181,181,1)',
                     }}
                     source={require('../../assets/resourceItem.png')}
                  />
               </View>
            </View>
         </View>
      </View>
   );
};

const styles = StyleSheet.create({
   item: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginHorizontal: 0,
      minHeight: rowHeight,
      backgroundColor: '#454545',
      borderRadius: 4,
   },
   title: {
      fontSize: !isLandscapeMode ? 12 : 20,
      fontFamily: FONT_FAMILY_REGULAR,
      marginLeft: 16,
      marginRight: 10,
      color: 'white',
      fontWeight: '600',
      opacity: 1,
      width: textWidth,
   },
   serialTitle: {
      fontSize: !isLandscapeMode ? 16 : 24,
      fontWeight: '600',
      fontFamily: FONT_FAMILY_REGULAR,
      color: courseSerialNumberColor,
      textAlign: 'center',
      maxWidth: rowHeight,
   },
});

export default CourseResourceItem;
